/**
 * @module events/types/mouseOut
 */

/**
 * @type {string}
 */
export default 'mouseout'
